
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[searchquery]",
      function () {
        return require("private-next-pages/s/[searchquery].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[searchquery]"])
      });
    }
  